import { normalizeFetchNotificationsResponse } from './utils/normalizers/notification.api.normalizers'
import baseApi from './base.api'
import { onMarkNotificationsAsReadQueryStarted } from './utils/response-handlers/notification.api.response-handlers'

export const notificationApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        fetchNotifications: builder.query({
            query: args => ({
                url: `/notifications/`,
                method: 'GET',
                params: {
                    page: args?.page || 1,
                    page_size: args?.pageSize || 10,
                    unread_only: args?.unreadOnly || false,
                },
            }),
            transformResponse: normalizeFetchNotificationsResponse,
            // Only have one cache entry because the arg always maps to one string
            serializeQueryArgs: ({ endpointName }) => endpointName,
            // Always merge incoming data to the cache entry
            merge: (currentCache, responseData) => {
                currentCache.notifications.push(...responseData.notifications)
            },
            // Refetch when the page arg changes
            forceRefetch: ({ currentArg, previousArg }) => (currentArg?.page ?? 1) !== (previousArg?.page ?? 1),
        }),
        markNotificationsAsRead: builder.mutation({
            query: ({ ids }) => ({
                url: `/notifications/mark-as-seen`,
                method: 'POST',
                body: ids,
            }),
            onQueryStarted: onMarkNotificationsAsReadQueryStarted,
        }),
        deleteNotifications: builder.mutation({
            query: ({ ids }) => ({
                url: `/notifications/delete`, // todo correct if needed
                method: 'POST',
                body: ids,
            }),
        }),
    }),
})

export const { useFetchNotificationsQuery, useMarkNotificationsAsReadMutation } = notificationApi
